import { Customer           }   from  "./customer.model"
import * as firestoreService    from  '../../../../common/firestore.service';
import { getUser } from "../../../login/login.service";

export function getAllCustomers(next: any) {
    const userEmail = getUser().email;
    firestoreService.fetchSubCollection('Users', userEmail, 'Customers', Customer, next);
}

// export function getAllCustomerRef(): Promise<CustomerRef[]> {
//     const userEmail = getUser().email;
//     return firestoreService.fetchSubCollection('Users', userEmail, 'Customers', CustomerRef);
// }

export function getAllCustomerRefRealTime(next: any): Promise<Customer[]> {
    const userEmail = getUser().email;
    return firestoreService.fetchSubCollectionRealTime('Users', userEmail, 'Customers', Customer, next);
}

export function getCustomer(id: string, next: any) {
    const userEmail = getUser().email;
    firestoreService.fetchSubDocument('Users', userEmail, 'Customers', id, Customer, next);
}

export function getCustomerPromise(id: string) {
    const userEmail = getUser().email;
    return firestoreService.fetchSubDocumentPromise('Users', userEmail, 'Customers', id, Customer);
}


export function addCustomer(customer: Customer): Promise<any> {
    const userEmail = getUser().email;
    const id = firestoreService.getRandomIDInCollection(`Users/${userEmail}/Customers`);
    customer.id = id;
    return firestoreService.addSubDocument('Users', userEmail, 'Customers', id, customer.toJson());
}

export function editCustomer(id: string, customer: Customer): Promise<any> {
    const userEmail = getUser().email;
    return firestoreService.updateSubDocument('Users', userEmail, 'Customers', id, customer.toJson());
}